import { DateTime } from 'luxon';

import { DateRangeRequest } from '@core/api/multi-site-dashboard/multi-site-dashboard.models';

import { EnergyCostRange } from '../../enums/energy-cost-range.enum';

const ISO_DATE_FORMAT = 'yyyy-MM-dd';

// Builds the inclusive [start, end] window for the energy-cost endpoint: `end` is today and `start`
// is `range - 1` days earlier, so the chart spans exactly `range` calendar days.
export const buildEnergyCostDateRange = (range: EnergyCostRange): DateRangeRequest => {
  const end = DateTime.now().startOf('day');
  const start = end.minus({ days: range - 1 });

  return {
    start: start.toFormat(ISO_DATE_FORMAT),
    end: end.toFormat(ISO_DATE_FORMAT),
  };
};
